<template>
  <div style="overflow: hidden" v-if="contentFetched">
    <!--msg left-aligned-images-->
    <div
      v-rellax="{ speed: 1, center: true }"
      class="msg-left position-absolute d-none d-md-block"
    >
      <img
        width="170px"
        src="../../assets/img/home/msg-left.png"
        alt=""
        class=""
      />
    </div>
    <!--<div class="msg-left-offset position-absolute d-none d-sm-block">-->
    <!--<img width="250px" src="../../assets/svg/home/msg-left-offset.svg" alt="" class="">-->
    <!--</div>-->
    <!--END msg left-aligned-images-->

    <!--msg right-aligned-images-->
    <div
      v-rellax="{ speed: -1, center: true }"
      class="msg-right position-absolute d-none d-lg-block"
    >
      <img
        width="100px"
        src="../../assets/img/home/msg-right.png"
        alt=""
        class=""
      />
    </div>
    <div class="msg-right-offset position-absolute d-none d-sm-block">
      <img
        width="250px"
        src="../../assets/svg/home/msg-right-offset.svg"
        alt=""
        class=""
      />
    </div>
    <!--END msg right-aligned-images-->

    <!--header-->
    <div
      class="hero position-relative"
      v-lazy:background-image="{
        src: require('../../assets/img/hero8.png'),
        loading: require('../../assets/img/hero8-loader.jpg'),
      }"
    >
      <div class="container hero-text">
        <div class="row">
          <div class="text-center">
            <div
              class="text-white text-uppercase text-bold w-title animated fadeInLeft"
            >
              welcome to
            </div>
            <hr class="head-line-gradient animated zoomIn" />
            <div
              class="text-white text-bold evt-name animated fadeInRight delay-1s"
            >
              Leicester Caribbean <br />Carnival
            </div>
          </div>
        </div>
      </div>

      <div
        id=""
        class="d-flex justify-content-center my-5 my-sm-0 animated bounce w-100 scrolldown"
        style="z-index: 1"
      >
        <span
          class="bg-white shadow-sm section-nav pointer d-flex d-md-none"
          @click="scrollToSection('scroll-down', 120)"
          data-aos="fade-down"
          data-aos-duration="3000"
          data-aos-easing="ease-in-out-back"
          data-aos-offset="-500"
          data-aos-once="true"
          data-aos-delay="5000"
        >
          <img src="../../assets/svg/arrow-down.svg" alt="" class="" />
        </span>
      </div>
      <div class="container-fluid position-absolute bottoms-up hero-aside">
        <div class="row no-gutters">
          <div class="col-12">
            <div class="row">
              <!--bottom-half-1-->
              <div
                class="see-through col-lg-6 py-4 px-3 px-sm-4 px-xl-5 d-flex flex-column mt-n4 mt-lg-0"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-ease="ease-in-out-back"
                data-aos-once="true"
                data-aos-delay="700"
              >
                <!--head-->
                <div
                  class="d-flex align-items-center mb-3 justify-content-center justify-content-md-start"
                >
                  <img
                    :src="require('../../assets/svg/sun.svg')"
                    alt=""
                    height="25"
                    class="mr-3"
                  />
                  <h6 class="font-weight-bold text-blue f-14 m-0 text-nowrap">
                    <span class="text-yellow">Upcoming Event: </span>Leicester
                    Caribbean Carnival
                  </h6>
                </div>
                <!--event-details-->
                <div class="row mb-3 my-sm-3">
                  <div
                    class="details col-md-3 my-4 my-lg-2 text-blue-dull text-center text-sm-left"
                  >
                    <h4 class="">1st Aug</h4>
                    <p class="m-0">
                      <small>Saturday</small>
                    </p>
                  </div>
                  <div
                    class="details col-md-5 my-4 my-lg-2 text-blue-dull border-right border-left border-warning pl-0 pl-sm-5 text-center text-sm-left"
                  >
                    <h4 class="">Victoria Park</h4>
                    <p class="m-0">
                      <small>Leicester LE1 7RY</small>
                    </p>
                  </div>
                  <div
                    class="details col-md-4 my-4 my-lg-2 text-blue-dull pl-0 pl-sm-5 text-center text-sm-left"
                  >
                    <h4 class="">
                      From 12 PM
                      <!-- {{ event.gatesOpen }} -->
                    </h4>
                    <p class="m-0">
                      <small>Opening Ceremony</small>
                    </p>
                    <p class="m-0">
                      <small>12PM at the African Caribbean Centre</small>
                    </p>
                    <p class="m-0"><small>LE2 0UA</small></p>
                  </div>
                </div>
                <!--buttons-->
                <div
                  class="order-first order-sm-last mb-4 mb-sm-0 d-flex align-items-center justify-content-center justify-content-md-start flex-column flex-md-row"
                >
                  <b-button
                    @click="goToTicketList"
                    class="btn-welcome btn-carnival bg-lilac my-1 my-lg-0 px-5 px-md-3 py-4 py-lg-0"
                  >
                    Book Tickets
                  </b-button>
                  <b-button
                    @click="downloadFile('https://forms.gle/5C5TSbohtb25UWNTA')"
                    class="btn-welcome btn-carnival bg-blue mx-1 mx-md-3 my-1 my-lg-0 px-5 px-md-3 py-4 py-lg-0"
                  >
                    <!-- @click="downloadFile(vendorRegFile.url)" -->
                    Vendor Registration
                  </b-button>
                  <b-button
                    @click="toRoute('/carnival')"
                    class="btn-welcome btn-carnival bg-green my-1 my-lg-0 px-5 px-md-3 py-4 py-lg-0"
                  >
                    Full Carnival Info
                  </b-button>
                </div>
              </div>
              <!--bottom-half-2-->
              <div
                class="col-lg-6 d-none d-lg-block"
                data-aos="fade-down"
                data-aos-duration="1000"
                data-aos-ease="ease-in-out-back"
                data-aos-once="true"
                data-aos-delay="700"
              >
                <div class="row h-100 d-flex">
                  <!--diary-img-->
                  <div class="col-6 p-0">
                    <img
                      :src="images.landing"
                      alt=""
                      class="img-fluid img-diary position-absolute"
                    />
                  </div>
                  <!--diary-info-->
                  <div
                    class="col-6 bg-blue text-white py-4 d-flex flex-column align-items-start"
                  >
                    <div class="d-flex align-items-center ml-3 mb-3">
                      <img
                        :src="require('../../assets/svg/diary.svg')"
                        alt=""
                        height="25"
                        class="mr-2"
                      />
                      <h6 class="font-weight-bold m-0">
                        <span class="text-blue-50"
                          >{{ content.carnivalDiary.title }} </span
                        >{{ monthYear }}
                      </h6>
                    </div>
                    <p class="ml-3 my-auto ml-xl-4" style="font-size: 15px">
                      <small class="text-bold"
                        >{{ content.carnivalDiary.dateTime }}
                        {{ content.carnivalDiary.year }} <br />
                        <span class="diary-location">
                          {{ content.carnivalDiary.location }}</span
                        >

                        <!-- Carnival Launch at Humberstone
                        Gate, <br />
                        Leicester City Centre -->
                      </small>
                    </p>
                    <b-button
                      @click="toRoute('/carnival')"
                      class="ml-3 my-3 my-lg-0 ml-xl-4 btn-carnival bg-blue-50 px-2 px-md-4 mr-2 mr-md-4"
                      size="sm"
                      >Full Schedule
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--END header-->

    <!--message section-->
    <div id="scroll-down" class="container mt-200 message position-relative">
      <div class="row">
        <div
          class="text-blue-dull col-12 text-center text-blue mb-4 mb-lg-0 messages"
          data-aos="zoom-in-up"
          data-aos-duration="1000"
          data-aos-once="true"
        >
          <img class="rounded-circle" :src="images.welcome1" alt="" />
          <div class="sender font-weight-bold text-gradient">
            A message from
          </div>
          <div class="font-weight-bold sender-name">
            {{ content.welcome1.from }}
          </div>
          <p class="mt-4 font-weight-bold f-16" style="letter-spacing: 0.3px">
            {{ content.welcome1.summary }}
          </p>
          <p class="mt-43 lh-18 f-15 subtitletext">
            <!-- {{ messageBody }} -->
            The Carnival Village will be open from 10am to 8pm, filled with
            vibrant performances, cultural displays, music, food, arts, and the
            joyful spirit that makes this event so unique. We will begin our
            festivities with the Official Opening Ceremony at African Caribbean
            Centre, Maidstone Road, LE2 0UA, setting the tone for a day of
            celebration, reflection, and togetherness. Everyone is welcome, this
            is a day for families, friends, and communities to come together in
            unity and joy. Join us as we honour the legacy of the Caribbean and
            African diaspora and stand tall in the freedom to express who we
            are. See you there and may God bless you all. Warm regards, Dennis
            Christopher Chairman, Leicester Caribbean Carnival
          </p>
          <div v-if="showHiddenText" class="history-content mt-5">
            <h3 class="text-gradient f-32 text-bold mb-4">
              History of Carnival
            </h3>
            <p
              v-for="(paragraph, index) in carnivalHistory"
              :key="`carnival-history-${index}`"
              class="lh-18 f-15 subtitletext history-text"
            >
              {{ paragraph }}
            </p>
          </div>
          <b-button
            class="btn-resize btn-carnival bg-lilac px-4 mt-4 text-bold"
            style="height: 44px; width: 215px"
            @click="showHiddenText = !showHiddenText"
          >
            <template v-if="showHiddenText">Show Less</template>
            <template v-else>Read Full History</template>
          </b-button>
        </div>
      </div>
    </div>
    <div class="text-center mb-62 mt-100">
      <h2 class="text-gradient f-32 text-bold">
        {{ content.videoSection.title }}
      </h2>
    </div>
    <div
      class="container mb-100 position-relative flier-section"
      v-if="contentFetched && content.videoSection"
    >
      <div class="row">
        <div
          class="col-12 mb-4"
          data-aos="zoom-in-up"
          data-aos-duration="1000"
          data-aos-once="true"
        >
          <youtube
            style="width: 100%"
            :video-id="videoId"
            :player-vars="playerVars"
            ref="youtube"
            fitParent
          ></youtube>
          <!-- <div class="flier-card mx-auto ">
                        <div class="w-100 cover-bg" :style="{'background-image': `url(${flier.front})`}"></div>
                        <div class="info">
                            <span class="d-block f-28 title mb-4"> {{flier.name}}</span>
                            <span class="d-block f-28 date mb-4"> {{flier.date}}</span>
                            <div class="d-flex justify-content-between flex-column flex-sm-row">
                                <span>{{flier.venue}}<br> {{flier.city}}</span>
                                <b-button class="btn-resize btn-carnival bg-lilac px-3 text-bold mt-3 mt-sm-0"
                                          v-if="index === 0"
                                          style="height: 43px;" @click="goToTicketList">
                                    Book Tickets
                                </b-button>
                                <b-button class="btn-resize btn-carnival bg-lilac px-3 text-bold mt-3 mt-sm-0"
                                          style="height: 43px;" @click="showFlier(flier)" v-else>
                                    View Full Flier
                                </b-button>
                            </div>
                        </div>
                    </div> -->
        </div>
      </div>
    </div>
    <!--END message section-->

    <!--schedule section-->
    <div class="img-schedule position-relative">
      <div
        v-rellax="{ speed: 2, center: true }"
        class="schedule-left position-absolute"
      >
        <img
          width="200px"
          src="../../assets/img/home/schedule-left.png"
          alt=""
          class=""
        />
      </div>
      <div class="schedule-left-offset position-absolute">
        <img
          src="../../assets/img/home/schedule-left-offset.png"
          alt=""
          class=""
        />
      </div>
      <div
        v-rellax="{ speed: -2, center: true }"
        class="schedule-right position-absolute"
      >
        <img
          width="50px"
          src="../../assets/img/home/schedule-right.png"
          alt=""
          class=""
        />
      </div>
      <div class="container-fluid p-5">
        <div class="row">
          <div class="col-lg-4 text-center">
            <div
              class="rounded-circle img-blue-attire"
              v-lazy:background-image="{
                src: images.scheduleLg,
                loading: require('../../assets/img/loading.gif'),
              }"
            ></div>
            <div
              class="rounded-circle img-cute-girl position-absolute"
              v-lazy:background-image="{
                src: images.scheduleSm,
                loading: require('../../assets/img/loading.gif'),
              }"
            ></div>
            <!--<img height="100px" class="position-absolute rounded-circle cute-girl" src="../../assets/img/cute-girl.png" alt="">-->
          </div>
          <div class="col-lg-8 section-sch home">
            <div class="d-flex align-items-center">
              <img
                :src="require('../../assets/svg/eye-mask.svg')"
                alt=""
                height="25"
                class="mr-2"
              />
              <p class="font-weight-bold m-0 text-blue-50">
                {{ featuredDay ? featuredDay.date : '' }}
              </p>
            </div>
            <h2 class="text-white font-weight-bold">Carnival Day</h2>
            <h6 class="text-blue-alt text-bold f-23">
              {{ featuredDay.description }}
            </h6>

            <dl class="row text-white mt-4 px-3">
              <div class="w-100">
                <div
                  class="row no-gutters justify-content-between"
                  v-for="(slot, index) in featuredDay.timeSlots.slice(0, 5)"
                  :key="`slot-${index}`"
                >
                  <dt
                    class="d-flex col-md-3 py-1"
                    data-aos="slide-up"
                    data-aos-offset="100"
                    data-aos-easing="ease-out-back"
                    data-aos-once="true"
                  >
                    <icon-vue
                      style="font-size: 6px"
                      class="mr-2 mt-2"
                      :class="setTagColor(index)"
                      icon="circle"
                      size="xs"
                    ></icon-vue>
                    <p class="m-0">
                      {{ slot.start }}
                      <span v-if="slot.end">- {{ slot.end }}</span>
                    </p>
                  </dt>
                  <dd
                    class="d-flex flex-column col-md-9 py-1 m-0"
                    data-aos="slide-up"
                    data-aos-offset="100"
                    data-aos-easing="ease-out-back"
                    data-aos-once="true"
                  >
                    <p class="m-0">{{ slot.title }}</p>
                    <p class="m-0 text-blue-50">
                      <small class="text-bold subtitle-text">
                        {{ slot.subtitle }}
                      </small>
                    </p>
                  </dd>
                  <hr class="w-100 border-white" />
                </div>
              </div>
            </dl>
            <b-button
              @click="toRoute('/carnival')"
              class="btn-carnival btn-welcome bg-blue-50 px-4 mt-3 py-4 py-lg-0"
            >
              Full Day Diary
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <zoom-modal ref="map-zoom-container">
      <div slot="content" class="w-100 my-3">
        <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="0"
          controls
          indicators
          img-width="500"
          img-height="650"
          :background="'transparent'"
          v-if="!!activeFlier"
        >
          <b-carousel-slide :background="'transparent'">
            <img
              slot="img"
              class="d-block mx-auto fly-img w-100"
              height="650"
              :src="activeFlier.front || ''"
              alt="image slot"
            />
          </b-carousel-slide>
          <b-carousel-slide :background="'transparent'">
            <img
              slot="img"
              class="d-block mx-auto fly-img w-100"
              height="650"
              :src="activeFlier.back || ''"
              alt="image slot"
            />
          </b-carousel-slide>
        </b-carousel>
      </div>
    </zoom-modal>

    <!--END schedule section-->

    <!-- <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <span class="close-button" @click="closeModal">&times;</span>
        <img
          src="../../assets/img/home/announcement.jpg"
          alt="Ad or Announcement"
          class="modal-image"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
import { getIdFromUrl } from 'vue-youtube';
import { mapState } from 'vuex';
import { dbRefs } from '../../services/firebase/init';
import EventMixin from '../../mixins/eventInfo';
import { EventBus } from '../../eventBus';
import Flickity from 'vue-flickity';
import { truncate } from '@/utils/helpers';

export default {
  name: 'home',
  data() {
    return {
      content: {},
      images: {},
      activeFlier: null,
      slide: 0,
      showHiddenText: false,
      carnivalHistory: [
        'The Leicester Caribbean Carnival was founded in 1984 by Mrs Elvy Morton, sparked by a conversation with Walton George, also known as "Funny Man," who she acknowledged as the first person she shared her vision with. From that moment, the idea grew into a collective effort, bringing together dedicated community organisers including Linda Herbert, James Morton, Bernard Francis, David Cole and Malik Elhajj, with Gayle Morton serving as the first Secretary. Created during a time of rising racial tension, the Carnival was both a response to those challenges and a celebration marking 150 years since the emancipation of enslaved Africans in the Caribbean. The first official Carnival in 1985 set the foundation for what has become a defining cultural moment in Leicester, with Felicity McCarthy crowned as the first Carnival Queen, establishing a legacy of pride, identity and celebration from the outset.',
        'From those early beginnings, the Carnival has grown into one of the Midlands\' most vibrant and valued cultural events. Known for its colour, music, mas and movement, it has always been about more than the parade. It is about people. It is about community. Carnival is life, joyful, expressive, vibrant and proudly family-orientated, creating space for generations to come together in celebration and belonging. That spirit has been carefully nurtured over the years, particularly through the leadership of Dennis "Sugar" Christopher, whose long-standing commitment has been central to sustaining and protecting the Carnival. As he steps down this year, his contribution is recognised as a key part of the Carnival\'s journey and success.',
        'The Carnival now enters a new chapter, guided by a collective partnership between African Heritage Alliance, Opal22 Arts and Edutainment, The Race Equality Centre (TREC), Britians Got Reggae CIC and Zander Events. This new model reflects both the scale of the Carnival today and a shared commitment to its future. While the event continues to attract thousands each year, its purpose remains unchanged to celebrate Caribbean culture, to create joy, and to hold space for community, connection and pride. Leicester Caribbean Carnival continues to stand as a living, evolving expression of culture, shaped by those who built it and those who now carry it forward.',
      ],
      contentFetched: false,
      videoLink: 'https://youtu.be/wZGhYxfwVmk',
      playerVars: {
        modestbranding: 1,
        autoplay: 1,
      },
      showModal: true, // Add this line to control modal visibility
    };
  },
  mixins: [EventMixin],
  methods: {
    showFlier(flier = '') {
      this.activeFlier = flier;
      this.showZoomModal();
    },
    closeModal() {
      this.showModal = false;
    },
  },
  computed: {
    ...mapState({
      schedule: (state) => state.content.schedule,
      fliers: (state) => state.content.fliers,
    }),
    featuredDay() {
      // TODO: Add featured day prop to dates.
      return this.schedule ? this.schedule[0] : {};
    },
    player() {
      if (this.$refs.youtube) {
        return this.$refs.youtube.player;
      }
      return null;
    },
    videoId() {
      return getIdFromUrl(this.content.videoSection.url);
    },
    monthYear() {
      let { carnivalDiary } = this.content;
      carnivalDiary = carnivalDiary || {};
      return `${carnivalDiary.month} ${carnivalDiary.year}`;
    },
    messageBody() {
      if (this.showHiddenText) {
        return this.content.welcome1.messageBody;
      }
      return truncate(this.content.welcome1.messageBody, 280);
    },
  },
  watch: {
    async contentFetched(newValue) {
      const vm = this;
      setTimeout(async () => {
        if (newValue && vm.$refs.youtube) {
          await vm.$refs.youtube.player.mute();
          await vm.$refs.youtube.player.playVideo();
        } else {
          console.log('NO PLAYER');
        }
      }, 3000);
    },
  },
  async mounted() {
    const [content, images] = await Promise.all([
      this.fetchDocument(dbRefs.homeRef),
      this.fetchDocument(dbRefs.imgRef.doc('home')),
      this.fetchCollection({
        ref: dbRefs.flierRef,
        collectionName: 'fliers',
      }),
    ]);
    this.content = content;
    this.images = images;
    this.contentFetched = true;
    EventBus.$on('zoomHidden', () => {
      this.activeFlier = null;
    });
  },
};
</script>

<style scoped lang="scss">
.btn-welcome {
  @media (max-width: 568px) {
    width: 75%;
  }
}

.see-through {
  /*opacity: 0.7;*/
  background-color: #ffffffeb;
}

.hero {
  height: 100vh;
  width: 100%;
  background: no-repeat center left;
  /*background: url("../../assets/img/hero-img-gir 2.png") no-repeat center left;*/
  background-size: cover;
  @media (max-width: 576px) {
    height: 74vh;
    background: no-repeat top left;
    background-size: 950px;
  }
}

.img-diary {
  height: 100%;
  width: 100%;
  bottom: 0;
  object-fit: cover;
}

.icon-circle {
  display: inline-block;
  border-radius: 60px;
  box-shadow: 0 0 2px #888;
  padding: 0.5em 0.6em;
}

.img-blue-attire {
  margin-top: 180px;
  margin-bottom: 40px;
  height: 300px;
  width: 300px;
  background: no-repeat center left;
  background-size: cover;
  @media (min-width: 1200px) {
    height: 350px;
    width: 350px;
  }
  @media (max-width: 568px) {
    height: 200px;
    width: 200px;
    margin-top: 40px;
    margin-bottom: 57px;
    margin-left: -25px;
  }
}

.img-cute-girl {
  top: 0;
  right: 50px;
  margin-top: 40px;
  height: 150px;
  width: 150px;
  background: no-repeat center left;
  background-size: cover;
  @media (max-width: 568px) {
    height: 100px;
    width: 100px;
    top: 0;
    right: -5px;
    margin-top: 21px;
    /*margin-top: 9px;*/
  }
}

.welcome {
  top: 25%;
}

.evt-name {
  font-size: 60px;
  font-weight: bold;
  line-height: 0.96;
  letter-spacing: -0.6px;
  text-align: center;
  font-stretch: normal;
  font-style: normal;

  @media (max-width: 576px) {
    font-size: 40px;
  }
}

.loc-data {
  opacity: 0.93 !important;
  background-color: #ffffff;
}

.w-title {
  font-size: 15px;
  line-height: 4.13;
  letter-spacing: 7.1px;
}

.details {
  /*border-right: solid 3px #f8ac31;*/
  @media (max-width: 576px) {
    border: none !important;
    padding: 0 !important;
  }

  h4 {
    font-weight: bold;
    line-height: 1;
  }

  p {
    small {
      line-height: 1.33;
      color: #8c8da9;
      font-size: 15px;
    }
  }
}

.text-gray {
  color: #8c8da9;
}

.bx-fancy {
  -webkit-box-shadow: 10px 0px 12px -7px rgba(52, 58, 64, 0.1);
  -moz-box-shadow: 10px 0px 12px -7px rgba(52, 58, 64, 0.1);
  box-shadow: 10px 0px 12px -7px rgba(52, 58, 64, 0.1);
}

.messages {
  @media (min-width: 1025px) {
    padding: 0 120px !important;
  }

  @media (max-width: 1024px) {
    padding: 0 90px !important;
  }

  @media (max-width: 568px) {
    padding: 0 30px !important;
  }

  img {
    width: 102px;
    height: 102px;
    box-shadow: 8.8px 8.2px 20.8px 0.2px rgba(43, 46, 131, 0.22);
    background-color: #00aeef;
  }

  .sender {
    margin-top: 25px;
    line-height: 1.18;
    letter-spacing: -0.2px;
    margin-bottom: 16px;
  }

  .sender-name {
    font-size: 21.5px;
    font-weight: bold;
    line-height: 0.88;
    letter-spacing: -0.2px;
  }

  .mesg {
    font-size: 15px;
    line-height: 1.8;
  }

  .history-content {
    margin-left: auto;
    margin-right: auto;
    max-width: 900px;
    text-align: left;
  }

  .history-text {
    line-height: 1.8;
  }
}

hr[class='w-100 border-white'] {
  opacity: 0.3;
}

.wel-flex {
  flex-grow: 2;
  @media (max-width: 576px) {
    height: 100%;
  }
}

.p-extra {
  padding: 12px 22px;
}

.rounded-circle {
}

* {
  /*animation-duration: 2s !important;*/
}

.btn-carnival {
  @media (max-width: 568px) {
    height: 30px;
    padding: 12px 8px;
  }
}

.bottoms-up {
  bottom: 0;
  @media (max-width: 768px) {
    top: 100%;
  }
}

.mt-header-text {
  margin-top: 215px;
  margin-left: auto;
  margin-right: auto;
  @media (max-width: 576px) {
    margin-top: 35%;
    background-color: white;
    padding-bottom: 25px;
  }
}

.scrolldown {
  text-align: center;
  top: 120%;
}

.message {
  @media (max-width: 1024px) {
    margin-top: 20%;
  }
  @media (max-width: 768px) {
    margin-top: 40%;
  }
  @media (max-width: 568px) {
    margin-top: 156%;
  }
}

.msg-left {
  left: 0;
  top: 31%;
}

.msg-right {
  right: 0;
  top: 25%;
}

.msg-right-offset {
  right: 25%;
  top: 43%;
  /*z-index: 1;*/
}

.msg-left-offset {
  left: 35%;
  top: 52%;
  z-index: -10;
  @media (max-width: 1024px) {
    top: 57%;
  }
}

.schedule-left {
  left: 0;
  top: 18%;
  @media (max-width: 568px) {
    /*height: 50px;*/
    left: -55px;
    top: 11%;
  }
}

.schedule-left-offset {
  left: 18%;
  top: 64%;
  z-index: 9;
  @media (max-width: 568px) {
    /*height: 50px;*/
    left: 65%;
    top: 12%;
  }

  img {
    width: 100px;
    @media (max-width: 568px) {
      width: 80px;
    }
  }
}

.schedule-right {
  right: 0;
  top: 31%;
}

.btn-resize {
  @media (max-width: 576px) {
    /*width: 48%;*/
    font-size: 13px;
    /*height: 42px;*/
    font-weight: bold;
  }
}

.flier-card {
  width: 100%;
  max-width: 436px;
  height: auto;
  box-shadow: 17.2px 24.6px 60px 0 rgba(0, 0, 0, 0.09);
  background-color: #ffffff;

  .cover-bg {
    height: 306px;
    /*background-image: url("../../assets/img/CARNIVAL-FRONT.jpg");*/
  }

  .info {
    padding: 34px 32px;

    .title {
      font-size: 23.5px;
      font-weight: bold;
      line-height: 1.19;
      color: #565887;
      width: 100%;
      max-width: 216px;
    }

    .date {
      font-size: 19.5px;
      line-height: 1.54;
      color: #ff9240;
      font-weight: bold;
    }

    .d-flex {
      .btn-resize {
        width: 100%;
        @media (min-width: 576px) {
          width: 150px;
        }
      }

      span {
        font-size: 15px;
        line-height: 1.33;
        text-align: left;
        color: #565887;
      }
    }
  }
}

.fly-img {
  -o-object-fit: contain;
  object-fit: contain;
}
.diary-location {
  display: block;
  max-width: 227px;
}
/* .hero-aside {
  transform: translateY(110%);
} */
.mt-380 {
  margin-top: 380px;
  @media (max-width: 568px) {
    margin-top: 620px;
  }
}
.hero-text {
  position: absolute;
  top: 38%;
  transform: translateY(-50%);
  width: fit-content;
  @media (max-width: 568px) {
    top: 45%;
  }
}
.dark-backdrop {
  background-color: rgba(0, 0, 0, 0.5); /* Black background with 50% opacity */
  padding: 20px; /* Optional: Add some padding to the container */
  border-radius: 8px; /* Optional: Add rounded corners */
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0.4),
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0.3),
    rgba(0, 0, 0, 0.3),
    rgba(0, 0, 0, 0.3)
  );
  z-index: 1;
}
.hero-text,
.hero-aside {
  position: relative;
  z-index: 2;
}

/* Modal overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal content */
.modal-content {
  position: relative;
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
  text-align: center;
}

@media (min-width: 768px) {
  .modal-content {
    max-width: 50%; /* Adjust the width as needed */
    max-height: 70%; /* Adjust the height as needed */
  }
}

/* Close button */
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}

/* Modal image */
.modal-image {
  max-width: 100%;
  height: auto;
}
</style>
